const visileColumns = [
  {
    title: "To Department",
    field: "To_Department",
    locked: false,
    filter: "text",
    width: "400px",
    show: true,
  },
  {
    title: "Type",
    field: "Type",
    locked: false,
    filter: "text",
    width: "300px",
    show: true,
  },
  {
    title: "Action Date",
    field: "Action_Date",
    locked: false,
    filter: "date",
    format: "DD/MM/yyyy",
    editor: "date",
    width: "400px",
    show: true,
  },
];

export default visileColumns;
